var _mask, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C9.10457 14 10 14.8954 10 16ZM18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16ZM24 18C25.1046 18 26 17.1046 26 16C26 14.8954 25.1046 14 24 14C22.8954 14 22 14.8954 22 16C22 17.1046 22.8954 18 24 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C9.10457 14 10 14.8954 10 16ZM18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16ZM24 18C25.1046 18 26 17.1046 26 16C26 14.8954 25.1046 14 24 14C22.8954 14 22 14.8954 22 16C22 17.1046 22.8954 18 24 18Z",
    fill: "#3A373A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20C10.2091 20 12 18.2091 12 16H8V20ZM4 16C4 18.2091 5.79086 20 8 20V16H4ZM8 12C5.79086 12 4 13.7909 4 16H8V12ZM12 16C12 13.7909 10.2091 12 8 12V16H12ZM16 20C18.2091 20 20 18.2091 20 16H16V20ZM12 16C12 18.2091 13.7909 20 16 20V16H12ZM16 12C13.7909 12 12 13.7909 12 16H16V12ZM20 16C20 13.7909 18.2091 12 16 12V16H20ZM24 16V20C26.2091 20 28 18.2091 28 16H24ZM24 16H28C28 13.7909 26.2091 12 24 12V16ZM24 16V12C21.7909 12 20 13.7909 20 16H24ZM24 16H20C20 18.2091 21.7909 20 24 20V16Z",
    fill: "#E9E9E9",
    mask: "url(#path-2-inside-1)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f6ec414c.svg";
export { ForwardRef as ReactComponent };